<template>
  <VueOnGeoAutocomplete label="Kraków Wadowicka 8A"
                        :url="realUrl"
                        text="title"
                        value="title"
                        title="title"
                        subTitle="subTitle"
                        :wrapper="wrapItem"
                        @selected="selected"></VueOnGeoAutocomplete>
</template>

<script>
import VueOnGeoAutocomplete from "./vue-ongeo-autocomplete.vue";

export default {
  name: "vue-ongeo-postal-code-search-autocomplete",
  components: {
    VueOnGeoAutocomplete
  },
  props: {
    url: { type: String }
  },
  computed: {
    realUrl () {
      return this.url
        ? this.url
        : process.env.VUE_APP_SEARCH_POSTAL_CODE_SERVICE_URL +
        `?api_key=${
        process.env.VUE_APP_API_KEY
        }&additionalData=address&query=`;
    }
  },
  methods: {
    wrapItem (entry) {
      let { label, address } = entry;
      let postalCode = entry.postalCodes.join(", ");
      let subTitle = [];

      if (address.municipality) subTitle.push(`gm. ${address.municipality}`);

      subTitle.push("<strong>" + postalCode + "</strong> ");

      if (entry.postalCodes.length != entry.numberOfPostalCodes)
        subTitle.push(`... ${entry.numberOfPostalCodes} kodów pocztowych`);

      return {
        title: label,
        subTitle: subTitle.join(" "),
        address: entry
      };
    },
    selected (item) {
      this.$emit("selected", item);
    }
  }
};
</script>
